<ion-header class="qvs-status-screen__header">
  <qvs-page-header-close
    *ngIf="showHeaderCloseButton"
    [title]="showTitle ? title || ('shared.STATUS_SCREEN' | translate) : ''"
    (closed)="closed.emit()"
  >
  </qvs-page-header-close>
  <qvs-page-header
    *ngIf="showHeaderCloseButton === false"
    [title]="showTitle ? title || ('shared.STATUS_SCREEN' | translate) : ''"
  >
  </qvs-page-header>
</ion-header>
<ion-content class="qvs-status-screen__content" [class.has-button]="showCloseButton">
  <qvs-status-screen-banner
    [bannerSrc]="statusScreenBannerUrlMap.get(type)"
    [iconSrc]="statusScreenIconUrlMap.get(type)"
    [rotate]="type === statusScreenType.PENDING"
  >
  </qvs-status-screen-banner>
  <div class="qvs-status-screen__content__description">
    <ng-content></ng-content>
  </div>
</ion-content>
<ion-button
  *ngIf="showCloseButton"
  [ngClass]="
    type === statusScreenType.PENDING ? 'qvs-status-screen__content__button-cancel' : 'qvs-status-screen__content__button'
  "
  (click)="closed.emit()"
>
  {{ closeButtonText }}
</ion-button>
